<template>
  <b-modal
    id="AddCandidate-TalentPool"
    size="xl"
    centered
    :visible="showTalentPool"
    hide-footer
    hide-header
    no-close-on-backdrop
    @hidden="$emit('close-modal', 'close')"
  >
    <b-overlay :show="showSpinner" rounded="sm">
      <div class="cs-modal-header">
        <div class="b-modal-header">Add candidates from Talent Pool</div>
        <div>
          <img
            @click="$emit('close-modal', 'close')"
            class="rotate-on-hover"
            src="../../../assets/img/accessconnew/blueCross.svg"
            alt=""
          />
        </div>
      </div>
      <div>
        <div
          class="
            border-bottom
            d-flex
            justify-content-between
            align-items-center
            pl-4
            p-3
          "
        >
          <span class="b-modal-inputs-heading">List of Candidates</span>

          <div
            class="d-flex switchtext pointer relativeclass add-candidate-job"
          >
            <div class="position-relative bluebtn">
              <b-button
                class="acs-addBtn-modal w-100px"
                @click="vendor ? addToJD() : addtoJob()"
                :disabled="isEmpty"
                :class="
                  showSpinner ? 'upload-loader-class defaultCursor' : 'pointer'
                "
              >
                <img
                  v-if="!showSpinner"
                  src="../../../assets/img/accessconnew/whitePlus.svg"
                  alt=""
                  class="mr-2"
                />
                {{ showSpinner ? "" : "Add to Job" }}</b-button
              >
              <div v-if="showSpinner" class="add-loader-pos">
                <Loader />
              </div>
            </div>

            <div class="bluebtn">
              <b-button
                @click="goToAddCandidate()"
                class="acs-addBtn-modal ml-2 pl-3 pr-3 add-new-cand"
              >
                <img
                  src="../../../assets/img/accessconnew/whitePlus.svg"
                  alt=""
                  class="mr-2"
                />
                <span class="">Add New Candidate</span>
              </b-button>
            </div>
          </div>
        </div>
        <div
          class="
            d-flex
            justify-content-between
            align-items-center
            w-100
            pt-3
            pl-3
            pr-3
            pb-0
          "
        >
          <div class="exc-seacrh position-relative w-50">
            <span>
              <img
                class="search-pos"
                src="../../../assets/img/search-bar-icon.svg"
                alt=""
              />
            </span>
            <b-form-input
              class="search-input"
              type="search"
              placeholder="Search Candidate"
              v-model="searchQuery"
              @input="getTalentPoolCandidateRedis()"
              @keyup="getTalentPoolCandidateRedis()"
            ></b-form-input>
          </div>

          <div class="d-flex align-items-center">
            <div class="tp-bluetxt mr-4">
              Selected Candidates:&nbsp; {{ selectedCandidateCount }}
            </div>
            <div class="position-relative bluebtn">
              <b-button
                class="acs-addBtn"
                ref="filter-btn"
                @click="showFilter()"
                ><img
                  class="mr-2"
                  src="../../../assets/img/accessconnew/whiteFilter.svg"
                  alt=""
                />
                <div
                  class="mb-3"
                  style="position: absolute; top: 1px; left: 38px"
                  v-if="filtercount != 0"
                >
                  <img src="../../../assets/panelist/fil_selected.svg" alt="" />
                </div>
                Filter</b-button
              >
              <div
                style="top: 35px; right: 0px"
                v-if="showfiltercard"
                class="acs-filter p-3"
                ref="filter-box"
                v-closable="{
                  exclude: ['filter-btn', 'filter-box'],
                  handler: 'hideFilterBox',
                }"
              >
                <b-row>
                  <b-col>
                    <div class="topDiv">
                      <label class="acs-input-head">Type</label>
                      <Select
                        :type="'filter'"
                        :dropdownOptions="filterTypeOpt"
                        :showError="false"
                        :disableDropdown="false"
                        :value="filterObject.filterType"
                        :placeholder="'Select Type'"
                        @setValue="filterObject.filterType = $event"
                      />
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <Sourcemulti
                      :label="'Source'"
                      :placeholder="'Select Source'"
                      :vmodel="filterObject.filterSource"
                      :hideVendor="$route.name === 'VendorKanban'"
                      :showThirdParty="showThirdParty"
                      @setValue="filterObject.filterSource = $event"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="topDiv mt-3" @click.stop="">
                      <FormTags
                        :label="'Skills'"
                        :mandatory="false"
                        :placeholder="'Enter Skills'"
                        :id="'kanbanskills'"
                        @select-value="filterObject.skillSets = $event"
                        :vmodel="filterObject.skillSets"
                      />
                    </div>
                  </b-col>
                </b-row>

                <!-- Added by -->
                <div
                  v-if="$route.name != 'VendorKanban'"
                  class="previewfdbck-tabs"
                >
                  <b-row>
                    <b-col>
                      <AddedByUsers
                        :placeholder="'Select'"
                        :label="'Added By'"
                        :vmodel="filterObject.createdByUserName"
                        @setValue="filterObject.createdByUserName = $event"
                      />
                    </b-col>
                  </b-row>
                </div>
                <div class="d-flex justify-content-between mt-4">
                  <b-button class="acs-cancelBtn-filter" @click="cancelFilter()"
                    >Cancel</b-button
                  >
                  <div class="d-flex">
                    <b-button
                      :disabled="!disableApplyFilter"
                      @click="
                        !disableApplyFilter && filtercount == 0
                          ? ''
                          : filtercount == 0
                          ? clearfilter(false)
                          : clearfilter(true)
                      "
                      class="acs-cancelBtn-filter mr-3"
                      >Reset</b-button
                    >
                    <b-button
                      :disabled="!disableApplyFilter && filtercount == 0"
                      @click="applyTalentFilterTest()"
                      class="acs-cancelBtn-filter"
                      >Apply</b-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <b-overlay :show="LoaderStatus" rounded="sm">
          <div class="exc-main-table">
            <div class="exc-table-head">
              <div class="common-single-checkbox pl-3" style="width: 5%">
                <b-form-checkbox
                  v-model="allSelected"
                  @change="selectAll()"
                ></b-form-checkbox>
              </div>
              <div style="width: 10%" class="d-flex align-items-center">
                <span class="mr-2">Source</span>

                <template v-if="statusValue == 'source'">
                  <img
                    v-if="sortByValue && filter"
                    class="pointer"
                    @click="
                      (sortByValue = !sortByValue),
                        getTalentPoolCandidateRedis()
                    "
                    src="../../../assets/img/accessconnew/ascSort.svg"
                    alt=""
                  />
                  <img
                    v-if="!sortByValue && filter"
                    class="pointer"
                    @click="
                      (sortByValue = !sortByValue),
                        getTalentPoolCandidateRedis()
                    "
                    src="../../../assets/img/accessconnew/descSort.svg"
                    alt=""
                  />
                </template>
                <img
                  v-else
                  @click="
                    (filter = true),
                      (statusValue = 'source'),
                      (sortByValue = true),
                      getTalentPoolCandidateRedis()
                  "
                  class="pointer"
                  src="../../../assets/img/accessconnew/nosort.svg"
                  alt=""
                />
              </div>
              <div style="width: 15%" class="d-flex align-items-center">
                <span class="mr-2">Candidate Name</span>
                <template v-if="statusValue == 'name'">
                  <img
                    v-if="sortByValue && filter"
                    class="pointer"
                    @click="
                      (statusValue = 'name'),
                        (sortByValue = !sortByValue),
                        getTalentPoolCandidateRedis()
                    "
                    src="../../../assets/img/accessconnew/ascSort.svg"
                    alt=""
                  />
                  <img
                    v-if="!sortByValue && filter"
                    class="pointer"
                    @click="
                      (statusValue = 'name'),
                        (sortByValue = !sortByValue),
                        getTalentPoolCandidateRedis()
                    "
                    src="../../../assets/img/accessconnew/descSort.svg"
                    alt=""
                  />
                </template>
                <img
                  v-else
                  @click="
                    (filter = true),
                      (statusValue = 'name'),
                      (sortByValue = true),
                      getTalentPoolCandidateRedis()
                  "
                  class="pointer"
                  src="../../../assets/img/accessconnew/nosort.svg"
                  alt=""
                />
              </div>
              <div style="width: 20%" class="d-flex align-items-center">
                <span class="mr-2">Email ID</span>
                <template v-if="statusValue == 'email'">
                  <img
                    v-if="sortByValue && filter"
                    class="pointer"
                    @click="
                      (statusValue = 'email'),
                        (sortByValue = !sortByValue),
                        getTalentPoolCandidateRedis()
                    "
                    src="../../../assets/img/accessconnew/ascSort.svg"
                    alt=""
                  />
                  <img
                    v-if="!sortByValue && filter"
                    class="pointer"
                    @click="
                      (statusValue = 'email'),
                        (sortByValue = !sortByValue),
                        getTalentPoolCandidateRedis()
                    "
                    src="../../../assets/img/accessconnew/descSort.svg"
                    alt=""
                  />
                </template>
                <img
                  v-else
                  @click="
                    (filter = true),
                      (statusValue = 'email'),
                      (sortByValue = true),
                      getTalentPoolCandidateRedis()
                  "
                  class="pointer"
                  src="../../../assets/img/accessconnew/nosort.svg"
                  alt=""
                />
              </div>
              <div class="" style="width: 15%">
                <span>Phone Number</span>
              </div>
              <div style="width: 20%" class="">
                <span class="">Skills</span>
              </div>
              <div style="width: 10%" class="d-flex align-items-center">
                <span class="mr-2">Status</span>

                <template v-if="statusValue == 'active'">
                  <img
                    v-if="sortByValue && filter"
                    class="pointer"
                    @click="
                      (statusValue = 'active'),
                        (sortByValue = !sortByValue),
                        getTalentPoolCandidateRedis()
                    "
                    src="../../../assets/img/accessconnew/ascSort.svg"
                    alt=""
                  />
                  <img
                    v-if="!sortByValue && filter"
                    class="pointer"
                    @click="
                      (statusValue = 'active'),
                        (sortByValue = !sortByValue),
                        getTalentPoolCandidateRedis()
                    "
                    src="../../../assets/img/accessconnew/descSort.svg"
                    alt=""
                  />
                </template>
                <img
                  class="pointer"
                  v-else
                  @click="
                    (filter = true),
                      (statusValue = 'active'),
                      (sortByValue = true),
                      getTalentPoolCandidateRedis()
                  "
                  src="../../../assets/img/accessconnew/nosort.svg"
                  alt=""
                />
              </div>
              <!-- <div class="text-center " style="width: 10%"> -->

              <!-- </div> -->
              <div style="width: 5%"><span class="">Action</span></div>
              <!-- <div class="text-center" style="width: 9%"> -->

              <!-- </div> -->
            </div>

            <div class="exc-table-body" id="top1">
              <template v-if="allCandidateDetails.length === 0">
                <div
                  class="h-100 d-flex justify-content-center align-items-center"
                  v-if="
                    !LoaderStatus &&
                    allCandidateDetails.length === 0 &&
                    searchQuery !== ''
                  "
                >
                  <div class="text-center">
                    <div>
                      <img
                        src="../../../assets/panelLog/searchnotfoundpan.svg"
                      />
                    </div>
                    <div class="notfoundimg mt-2 wordbreak">
                      No matching results for
                      <strong> "{{ searchQuery }}" </strong>
                    </div>
                  </div>
                </div>

                <div
                  v-else-if="
                    allCandidateDetails.length === 0 && searchQuery === ''
                  "
                  class="
                    d-flex
                    justify-content-center
                    align-items-center
                    h-100
                    flex-column
                  "
                >
                  <div>
                    <img src="../../../assets/panelLog/searchnotfoundpan.svg" />
                  </div>
                  <div class="search-result-empty-text mt-4">
                    {{
                      filtercount == 0
                        ? "There are no candidates to add to this Job"
                        : "No data found."
                    }}
                  </div>
                </div>
              </template>
              <template v-else>
                <div
                  v-for="(i, index) in allCandidateDetails"
                  :key="index"
                  :style="
                    candidateSelected.includes(i.candidateID) &&
                    'background : #E1EEF7 !important'
                  "
                  class="
                    exc-table-row
                    mt-3
                    d-flex
                    justify-content-between
                    align-items-center
                  "
                >
                  <div
                    style="width: 5%"
                    class="
                      pl-3
                      d-flex
                      justify-content-between
                      align-items-center
                    "
                  >
                    <div class="common-single-checkbox">
                      <b-form-checkbox
                        class=""
                        :disabled="
                          !candidateSelected.includes(i.candidateID) &&
                          candidateSelected.length >= addCount
                        "
                        :value="i.candidateID"
                        v-model="candidateSelected"
                        @change="deselect()"
                      >
                      </b-form-checkbox>
                    </div>
                  </div>
                  <div class="" style="width: 10%">
                    <img
                      v-if="convertToLowerCase(i.source) == 'linkedin'"
                      src="../../../assets/img/talentpool/linkdin.svg"
                      alt=""
                    />
                    <img
                      v-else-if="convertToLowerCase(i.source) == 'monster'"
                      src="../../../assets/img/talentpool/monster.svg"
                      alt=""
                    />
                    <img
                      v-else-if="convertToLowerCase(i.source) == 'naukri'"
                      src="../../../assets/img/talentpool/naukri.svg"
                      alt=""
                    />
                    <img
                      v-else-if="convertToLowerCase(i.source) == 'indeed'"
                      src="../../../assets/img/talentpool/indeed.svg"
                      alt=""
                    />
                    <img
                      v-else-if="convertToLowerCase(i.source) == 'seek'"
                      src="../../../assets/img/talentpool/seek.svg"
                      alt=""
                    />
                    <img
                      v-else-if="convertToLowerCase(i.source) == 'vendor'"
                      src="../../../assets/vendor-new-icon.svg"
                      alt=""
                    />
                    <img
                      v-else
                      src="../../../assets/img/talentpool/default.svg"
                      alt=""
                    />
                  </div>
                  <div style="width: 15%" class="text-truncate pr-1">
                    <span v-b-tooltip.hover.top="i.name" class="">
                      {{ i.name }}</span
                    >
                  </div>
                  <div class="text-truncate pr-1" style="width: 20%">
                    <span class="" v-b-tooltip.hover.top="i.email">
                      {{ i.email }}</span
                    >
                  </div>
                  <div style="width: 15%">{{ i.phoneNumber }}</div>
                  <div class="mr-1" style="width: 20%">
                    <div
                      class="text-truncate truncate-section"
                      v-b-tooltip.hover.top="i.skills.join(', ')"
                    >
                      {{ i.skills.join(", ") }}
                    </div>
                  </div>
                  <div
                    :class="{
                      activetext: i.active,
                      Inactivetext: !i.active,
                    }"
                    style="width: 10%"
                  >
                    {{ i.active ? "Active" : "Inactive" }}
                  </div>

                  <div class="text-center" style="width: 5%">
                    <!-- v-b-tooltip.hover.top="userStatus == 'Edit' ? '' : 'View'" -->
                    <img
                      v-b-tooltip.hover.top="'View'"
                      v-if="viewCandID != i.candidateID"
                      @click="$emit('view-candidate', i)"
                      src="../../../assets/img/accessconnew/blueEye.svg"
                      alt="/"
                      class="pointer mr-3"
                    />
                    <img
                      v-else
                      height="25"
                      width="25"
                      src="../../../assets/talentpool/notviewicon.svg"
                      alt=""
                      class="mr-3"
                    />
                    <!-- <img
                    class="pointer pr-3 mr-4"
                    src="../../assets/talentpool/download.svg"
                    alt=""
                  /> -->
                  </div>
                </div>
              </template>
            </div>
          </div>
        </b-overlay>
      </div>

      <!-- <div class="exc-table-body" id="top1"> -->
      <!-- <template v-if="allCandidateDetails.length === 0">
<div
                  v-if="
                    !LoaderStatus &&
                    allCandidateDetails.length === 0 &&
                    searchname !== ''
                  "
                  class="talentPool-table-row justify-content-center"
>
                  No matching results for&nbsp;
<strong> "{{ searchname }}" </strong>
</div>
 
                <div
                  v-else-if="
                    allCandidateDetails.length === 0 && searchname === ''
                  "
                  class="
                    d-flex
                    justify-content-center
                    align-items-center
                    h-100
                    flex-column
                  "
>
<div>
<img
                      src="../../assets/img/vendorcandidateanddashboard/no-candidates-added.svg"
                      alt=""
                    />
</div>
<div class="search-result-empty-text mt-4">
                    No data found.
</div>
</div>
</template> -->
      <!-- </div> -->
      <div
        class="
          acs-paginaTion-new
          d-flex
          justify-content-between
          align-items-center
        "
      >
        <div class="d-flex">
          <span class="acs-gotopage-text p-1 mr-2">Go to page</span>
          <b-form-input
            v-model="goToPage"
            @keyup.enter="goToPages()"
            @keypress="NumbersOnly"
            type="text"
            class="acs-pagination-num"
            @paste="handlePaste"
          ></b-form-input>
          <div
            class="acs-pagination-addbtn"
            @click="goToPages"
            :disabled="goToPage === null || goToPage == '' || !iscontainsNumber"
          >
            <span
              :class="
                goToPage === null || goToPage == '' || !iscontainsNumber
                  ? 'disableDeleteIcon pl-3 mt-1'
                  : 'pointer pl-3 mt-1'
              "
            >
              <img src="../../../assets/panelist/page_arrow.svg" alt />
            </span>
          </div>
        </div>

        <div class="pagination">
          <b-pagination
            v-model="currentPage"
            @input="getTalentPoolCandidateRedis(), (goToPage = null)"
            :total-rows="total"
            :per-page="pageCount"
            align="center"
            first-number
            last-number
          >
            <template #prev-text>
              <span>
                <img src="../../../assets/img/accessconnew/pageleft.svg" alt />
              </span>
            </template>
            <template #next-text>
              <span>
                <img src="../../../assets/img/accessconnew/pageright.svg" alt />
              </span>
            </template>
          </b-pagination>
        </div>
        <div class="d-flex align-items-center">
          <PageInput :pagecount="pageCount" @update-value="updatePage" />

          <div class="acs-gotopage-text mr-2 ml-4 d-flex justify-content-end">
            Showing :
            <div
              class="text-truncate ml-2 results-individual-width"
              v-if="pageStart > total"
            >
              0
            </div>
            <div class="text-truncate ml-2 results-individual-width" v-else>
              {{ pageStart }}
            </div>
            <div class="text-truncate results-individual-width">-</div>
            <div class="text-truncate results-individual-width">
              {{ pageEnd }}
            </div>
            <div class="text-truncate ml-1 results-individual-width">of</div>
            <div
              class="text-truncate ml-1 results-individual-width"
              style="max-width: 20%"
            >
              {{ total }}
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getVendorJdTalentPool,
  getCustomerFields,
  addtojd,
} from "../../../utils/apiFunctions";
import toast from "../../mixin/toast";
import { NumbersOnly } from "../../../controllers/Candidate/helpers";
import PageInput from "../../InputComponents/PaginationInput.vue";
import Select from "../../../components/fixedcomponents/Select.vue";
import AddedByUsers from "../../../components/fixedcomponents/TalentPool/AddedByUsers.vue";
import Sourcemulti from "../../../components/fixedcomponents/TalentPool/Source.vue";
import Loader from "../../../components/fixedcomponents/Loader.vue";
import commonFunc from "../../../components/mixin/commonFunctions.js";
import FormTags from "../../../components/InputComponents/FormTags";

export default {
  name: "AddFromTalentPool",
  props: {
    vendor: Boolean,
    showTalentPool: Boolean,
    particularJob: Object,
    viewCandID: String,
    positionIDs: Array,
  },
  mixins: [toast, commonFunc],
  data() {
    return {
      showfiltercard: false,
      showSpinner: false,
      PopupSourceof: "",
      storeFilterSource: [],
      storeFilterSkills: [],
      storeFilterAddedBY: [],
      storeFilterType: "",
      LoaderStatus: false,
      page: 0,
      type: 1,
      total: 0,
      currentPage: 1,
      filtercount: 0,
      pageCount: 10,
      addCount: this.vendor ? 50 : 20,
      pageEnd: null,
      pageStart: null,
      goToPage: null,
      searchQuery: "",
      checkMultiple: false,
      statusValue: "createdAt",
      addMultipleCandidates: false,
      sortByValue: false,
      allSelected: false,
      viewCandidateModal: false,
      applyflag: false,
      PopupAreaofexp: [],
      selCandData: [],
      filterTypeOpt: [
        {
          value: "2",
          text: "All",
        },
        {
          value: "1",
          text: "Active",
        },
        {
          value: "0",
          text: "Inactive",
        },
      ],
      filterObject: {
        filterType: "",
        filterSource: [],
        skillSets: [],
        createdByUserName: [],
      },
      selectedCandidate: {},
      advancedFilters: [],
      allCandidateDetails: [],
      candidateSelected: [],
      customFieldsArray: [],
    };
  },
  components: {
    PageInput,
    AddedByUsers,
    Sourcemulti,
    Select,
    Loader,
    FormTags,
  },
  computed: {
    ...mapGetters(["roles"]),
    isEmpty: ({ candidateSelected }) => candidateSelected.length === 0,
    selectedCandidateCount() {
      let count;
      count =
        this.candidateSelected.length < 9
          ? "0" + this.candidateSelected.length
          : this.candidateSelected.length;
      return count;
    },
    iscontainsNumber() {
      return /^[1-9]\d*$/.test(this.goToPage);
    },
    disableApplyFilter() {
      return (
        this.filterObject.filterType.length !== 0 ||
        this.filterObject.skillSets.length !== 0 ||
        this.filterObject.filterSource.length !== 0 ||
        this.filterObject.createdByUserName.length !== 0
      );
    },
    ...mapGetters("userVUEX", {
      thirdPartyData: "getThirdPartyData",
    }),
    checkThirdPartyAccess() {
      let val = this.thirdPartyData.data.find(
        (obj) => obj.thirdPartyID === "hire3xcvsearch"
      );
      if (!val) {
        return false;
      }
      return val.enabled;
    },
    showThirdParty() {
      return this.$route.name != "VendorKanban" && this.checkThirdPartyAccess;
    },
  },
  filters: {
    fnName: function (value) {
      if (Array.isArray(value)) {
        if (value.length <= 3) {
          return value.join(", ");
        } else {
          return value.slice(0, 3).join(", ") + "...";
        }
      } else {
        return value;
      }
    },
  },
  created() {
    this.candidateSelected = [];
    this.selCandData = [];
    this.getTalentPoolCandidateRedis();
    this.getCustomField();
  },
  watch: {
    candidateSelected(val) {
      if (val && val.length != 0) {
        this.allCandidateDetails.forEach((item) => {
          if (
            !this.selCandData.some(
              (targetItem) => targetItem.candidateID === item.candidateID
            ) &&
            val.includes(item.candidateID)
          ) {
            this.selCandData.push(item);
          }
        });
      }
      this.selCandData = this.selCandData.filter((obj) =>
        this.candidateSelected.includes(obj.candidateID)
      );
    },
  },
  methods: {
    cancelFilter() {
      this.filterObject.filterSource = this.storeFilterSource;
      this.filterObject.filterType = this.storeFilterType;
      this.filterObject.skillSets = this.storeFilterSkills;
      this.filterObject.createdByUserName = this.storeFilterAddedBY;
      this.showfiltercard = false;
    },
    clearfilter(flag) {
      this.applyflag = flag;
      this.filtercount = 0;
      this.filterObject = {
        filterType: "",
        filterSource: [],
        skillSets: [],
        createdByUserName: [],
      };
      if (this.applyflag) {
        this.showfiltercard = false;
        this.LoaderStatus = true;
        this.currentPage = 1;
        this.storeFilterSource = [];
        this.storeFilterType = "";
        this.storeFilterSkills = [];
        this.storeFilterAddedBY = [];
        this.getTalentPoolCandidateRedis();
      }
      this.applyflag = false;
    },
    applyTalentFilterTest() {
      this.LoaderStatus = true;
      this.filtercount = 0;
      this.showfiltercard = false;
      this.getTalentPoolCandidateRedis();
      this.storeFilterSource = this.filterObject.filterSource;
      this.storeFilterType = this.filterObject.filterType;
      this.storeFilterSkills = this.filterObject.skillSets;
      this.storeFilterAddedBY = this.filterObject.createdByUserName;
    },
    hideFilterBox() {
      this.showfiltercard = false;
    },
    showFilter() {
      if (this.showfiltercard) {
        this.showfiltercard = false;
      } else {
        this.filterObject.filterSource = this.storeFilterSource;
        this.filterObject.filterType = this.storeFilterType;
        this.filterObject.skillSets = this.storeFilterSkills;
        this.filterObject.createdByUserName = this.storeFilterAddedBY;
        this.showfiltercard = true;
      }
    },
    goToAddCandidate() {
      let query = {
        jobID: this.particularJob.jobID,
        customerID: this.particularJob.customerID,
      };
      if (this.$route.name == "VendorKanban") {
        query.client = this.$route.params.client;
        query.vendorID = this.$route.params.vendorID;
        query.clientName = this.$route.query.clientName;
        query.titleName = this.$route.query.titleName;
        query.jobTitle = this.$route.query.jobTitle;
        this.$router.push({
          name: "AddCandidateInVendor",
          query: query,
        });
      } else {
        query.cardName = this.$route.query.cardName;
        this.$router.push({
          name: "AddCandidateInJD",
          query: query,
        });
      }
    },
    checkSelectAll() {
      let isSelectedAll = true;
      if (this.allCandidateDetails.length !== 0) {
        for (let record of this.allCandidateDetails) {
          if (
            this.candidateSelected.filter(
              (value) => value == record.candidateID
            ).length === 0
          ) {
            isSelectedAll = false;
            break;
          }
        }
      } else {
        isSelectedAll = false;
      }
      this.allSelected = isSelectedAll;
      let values = this.allCandidateDetails.filter((obj) =>
        this.candidateSelected.includes(obj.candidateID)
      );
      if (values.length == 0) this.allSelected = false;
      else if (this.candidateSelected.length == this.addCount)
        this.allSelected = true;
    },
    addtoJob() {
      if (this.positionIDs.length > 1) {
        this.$emit("add-cand-job", this.selCandData);
      } else {
        this.addToJD("automatic");
      }
    },
    async addToJD(type) {
      this.showSpinner = true;
      try {
        let jobID = [];
        jobID.push(this.$route.query.jobID);
        const data = {
          candidateIDs: this.candidateSelected,
          jobIDs: jobID,
          vendorID: this.$route.params.vendorID,
        };
        if (type) data[type] = true;
        const response = await addtojd(data);
        if (response.status === 200) {
          this.showSpinner = false;
          this.allSelected = false;
          this.selectAll();
          this.$emit("close-modal", "candadded");
          let text;
          if (this.candidateSelected.length == 1) {
            text = "Candidate added successfully!";
          } else {
            text = "Candidates added successfully!";
          }
          this.$nextTick(() => {
            this.dynamicToast("success", `Successfully added`, text);
          });
        } else {
          this.showSpinner = false;
          this.errorModal("Something went wrong!");
        }
      } catch (error) {
        this.showSpinner = false;
        this.errorModal("Something went wrong!");
        this.candidateSelected = [];
      }
    },
    updatePage(value) {
      this.pageCount = value;
      this.currentPage = 1;
      this.getTalentPoolCandidateRedis();
    },
    NumbersOnly(evt) {
      NumbersOnly(evt);
    },
    goToPages() {
      if (this.goToPage >= 1) {
        this.currentPage = this.goToPage;
        this.goToPage = null;
      }
    },
    convertToLowerCase(data) {
      return data.toLowerCase();
    },
    handleAddCandidates(newVal) {
      this.addMultipleCandidates = newVal;
    },
    handleCloseMultple(newVal) {
      this.checkMultiple = newVal;
    },
    handleAdd(newVal) {
      this.addMultipleCandidates = newVal;
    },
    async getCustomField() {
      try {
        let parentID = "5";
        let response = await getCustomerFields({ parentID });
        if (response.status == 200) {
          this.customFieldsArray = response.data.data.fields;
        }
      } catch (error) {
        console.error(error);
      }
    },
    viewCandidate(cand) {
      this.selectedCandidate = cand;
      this.viewCandID = cand.candidateID;
      this.viewCandidateModal = true;
    },
    closeViewIcon() {
      this.viewCandidateModal = false;
      this.selectedCandidate = {}; // Update selectedCandidate based on the event
    },
    selectAll() {
      for (let i in this.allCandidateDetails) {
        if (
          this.allSelected &&
          this.candidateSelected.filter(
            (value) => value == this.allCandidateDetails[i].candidateID
          ).length === 0
        ) {
          if (this.candidateSelected.length < this.addCount) {
            this.candidateSelected.push(
              this.allCandidateDetails[i].candidateID
            );
          } else {
            this.dynamicToast(
              "warning",
              "Warning",
              `Cannot add more than ${this.addCount} candidates at once!`
            );
            break;
          }
        } else if (
          !this.allSelected &&
          this.candidateSelected.filter(
            (value) => value == this.allCandidateDetails[i].candidateID
          ).length > 0
        ) {
          this.candidateSelected.splice(
            this.candidateSelected.indexOf(
              this.allCandidateDetails[i].candidateID
            )
          );
        }
      }
      let values = this.allCandidateDetails.filter((obj) =>
        this.candidateSelected.includes(obj.candidateID)
      );
      if (values.length == 0) this.allSelected = false;
      else if (this.candidateSelected.length == this.addCount)
        this.allSelected = true;
    },
    deselect() {
      this.allSelected = false;
      const activeCandidateIDs = this.allCandidateDetails.map(
        (candidate) => candidate.candidateID
      );

      const containsAllActive = activeCandidateIDs.every((candidateID) =>
        this.candidateSelected.includes(candidateID)
      );

      if (containsAllActive) {
        this.allSelected = true;
      }
      let values = this.allCandidateDetails.filter((obj) =>
        this.candidateSelected.includes(obj.candidateID)
      );
      if (values.length == 0) this.allSelected = false;
      else if (this.candidateSelected.length == this.addCount) {
        this.allSelected = true;
        this.dynamicToast(
          "warning",
          "Warning",
          `Cannot add more than ${this.addCount} candidates at once!`
        );
      }
    },
    async getTalentPoolCandidateRedis() {
      this.applyflag = true;
      this.LoaderStatus = true;
      let payload = {
        type: this.filterObject.filterType,
        count: this.pageCount,
        page: this.currentPage - 1,
        jobID: this.particularJob.jobID,
        customerID: this.particularJob.customerID,
        sortBy: {
          column: this.statusValue,
          order: this.sortByValue,
        },
        searchQuery: this.searchQuery,
        source: this.filterObject.filterSource,
        skills: this.filterObject.skillSets,
        createdByUserName: this.filterObject.createdByUserName,
        popup: true,
      };
      this.filtercount = 0;
      if (this.$route.name == "VendorKanban") {
        payload.vendor = true;
      }

      // Check if filterType has keys and assign its value to payload.type
      if (
        this.filterObject.filterType.length !== 0 ||
        this.filterObject.skillSets.length !== 0 ||
        this.filterObject.filterSource.length !== 0 ||
        this.filterObject.createdByUserName.length !== 0
      ) {
        this.filtercount++;
        payload.type = this.filterObject.filterType
          ? this.filterObject.filterType
          : "2";
      } else {
        payload.type = "2"; // Default value
      }
      //   console.log(payload, "payload");

      //   if (this.roles.includes("GET_VENDOR_DASHBOARD")) {
      //     payload["vendor"] = true;
      //   }

      await getVendorJdTalentPool(payload)
        .then((res) => {
          if (res.status == 200) {
            this.allCandidateDetails = res.data.data.data;
            this.LoaderStatus = false;
            this.pageStart = res.data.data.pageStart;
            this.pageEnd = res.data.data.pageEnd;
            this.total = res.data.data.total;
            this.checkSelectAll();
            this.showfiltercard = false;
            // this.dbfilterdrop = false;
          } else {
            this.LoaderStatus = false;
          }
          const element = document.getElementById("top1");
          element.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        })

        .catch((err) => {
          this.LoaderStatus = false;
          throw err;
        });
    },
  },
};
</script>

<style scoped>
.acs-paginaTion-new1 {
  max-width: 99.7%;
  padding: 5px 10px;
  box-shadow: 0px 4px 15px 0px #c4c4c480;
  border-radius: 0px 0px 5px 5px;
  background: #fcfcfc;
  z-index: 1;
}
.upload-loader-class {
  opacity: 0.5;
  height: 30px;
  width: 137px;
}

.add-loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: 24px;
}
</style>
